<template>
  <div class="form-group" :class="{ 'has-danger' : errors.has(name) }">
    <div class="has-float-label">
      <input :style="styler" v-mask="mask" type="text" class="form-control" :id="name" :ref="name" :name="name" v-bind:value="value" v-validate="validation" v-on:input="onInput" :placeholder="placeholder ? placeholder : label" :readonly="readonly">
      <label :for="name">{{label}}</label>
      <div class="form-control-feedback" v-if="errors.has(name)">{{ errors.first(name) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: {
      type:[Number,String]
    },
    placeholder: String,
    readonly: String,
    name: String,
    mask: String,
    styler: {
      default:''
    },
    validation:{
      default: ''
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// FormTextMask.vue?609f1980